var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('employee-detail',{attrs:{"employee":_vm.item,"isLoading":_vm.isLoading,"panelInfoTitle":_vm.item.isAreaReferent ? 'Capo Area':'Agente'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }